import { render, staticRenderFns } from "./index-landing-two.vue?vue&type=template&id=1408f64a&"
import script from "./index-landing-two.vue?vue&type=script&lang=js&"
export * from "./index-landing-two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports